import { ModalBase } from '@repo/ui';
import { useState } from 'react';
import { InputGroup, Input, Button } from 'reactstrap';

interface IProps {
  isOpen: boolean;
  generatedKey: string;
  partnerName: string;
  toggleModal: () => void;
}

export const ModalShowKey = ({
  isOpen,
  generatedKey,
  partnerName,
  toggleModal,
}: IProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedKey).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  return (
    <ModalBase.Wrapper
      size="md"
      isOpen={isOpen}
      loading={false}
      toggle={toggleModal}
    >
      <ModalBase.Header toggle={toggleModal} withBorderBottom>
        Nova chave gerada — {partnerName}
      </ModalBase.Header>

      <ModalBase.Body>
        <div className="d-flex flex-column gap-3">
          <div className="alert alert-danger d-flex align-items-start gap-2 mb-0">
            <i className="ri-eye-off-line fs-5 mt-1 flex-shrink-0" />
            <div>
              <strong>Guarde esta chave agora.</strong>
              <p className="mb-0 mt-1">
                Esta é a única vez que a chave será exibida. Após fechar este
                modal não será possível recuperá-la. Copie e armazene em um
                local seguro antes de continuar.
              </p>
            </div>
          </div>

          <div>
            <label className="form-label fw-semibold">Chave de acesso</label>
            <InputGroup>
              <Input
                readOnly
                value={generatedKey}
                className="form-control font-monospace"
                style={{ letterSpacing: '0.05em' }}
              />
              <Button
                color={copied ? 'success' : 'primary'}
                onClick={handleCopy}
                style={{ minWidth: 110 }}
              >
                <i
                  className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} me-1`}
                />
                {copied ? 'Copiado!' : 'Copiar'}
              </Button>
            </InputGroup>
          </div>
        </div>
      </ModalBase.Body>

      <ModalBase.Footer>
        <ModalBase.Actions
          loading={false}
          goBack={toggleModal}
          actionBtnType="button"
          onConfirm={toggleModal}
          cancelBtnLabel="Fechar"
          confirmBtnLabel="Confirmar cópia e fechar"
          actionBtnColor="primary"
        />
      </ModalBase.Footer>
    </ModalBase.Wrapper>
  );
};
